import { Modal, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { configs, formatCurrency } from '../../../../assets/Config';
import '../../../../assets/styles/RM.css'
import { useLogin } from '../../../../services/contexts/AdminLoginContext';
import { useKYCContext } from '../../../../services/contexts/KYCContext';
import { useCRMContext } from '../../../../services/contexts/CRMContext';
import { useRMContext } from '../../../../services/contexts/RMContext';
import { useCMContext } from '../../../../services/contexts/companyManagement/CMContext';
import { getRemarkHistory } from '../../../../services/apis/CRMApi';

export default function CreateEntryPage() {

    const { setShowSuccess, token, logout, setLoginError } = useLogin()
    const { editRemark, setEditRemark, editRemarkData, setEditRemarkData, createOrderLead, getAllRemarkList, getAllRemarkListByUser, remarkList, remarkListType, setRemarkListType, customer, setCustomer, editOrderLead, getRemarkByRemarkType } = useCRMContext()
    const { getKYCVerifiedCustomer, kycVerifiedList } = useKYCContext()
    const { companyList } = useCMContext()

    const [CompanyName, setCompanyName] = useState({})
    const [lastCallDate, setLastCallDate] = useState("")
    const [remark, setRemark] = useState("")
    const [investable_surplus, setInvestable_surplus] = useState("")
    const [rate, setRate] = useState("")
    const [cQuote, setCQuote] = useState("")
    const [oQuote, setOQuote] = useState("")
    const [aQuote, setAQuote] = useState("")
    const [interested_in, setInterested_in] = useState("0")
    const [remarkHistory, setRemarkHistory] = useState("");
    const [quantity, setQuantity] = useState("");
    const [orderType, setOrderType] = useState("buy");

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [status, setStatus] = useState("");
    const [error, setError] = useState("")

    const history = useHistory()

    useEffect(async () => {
        try {
            if (editRemarkData && editRemarkData.id) {
                setRemark(editRemarkData.remark)
                setStatus(editRemarkData.status)
                setCQuote(editRemarkData.client_quote)
                setOQuote(editRemarkData.our_quote)
                setAQuote(editRemarkData.approved_quote)
                setQuantity(editRemarkData.quantity)
                setError("")

                let response = await getRemarkHistory(token, editRemarkData.id);
                if (response && response.status === 200) {
                    setRemarkHistory(response.data);
                } else if (response && response.status === 401) {
                    logout();
                    setLoginError(configs.unauthorizedErrorMessage);
                } else {

                }
            }

        } catch (error) {
            console.error(error)
        }
    }, [editRemarkData])


    const handleRMChange = (e, value) => {
        try {
            setCompanyName(value)
        } catch (error) {

        }
    }

    const handleCustomerChange = (e, value) => {
        try {
            setCustomer(value)
        } catch (error) {

        }
    }


    // add company function
    async function addRemark() {
        try {

            document.getElementById("newsBtn").classList.toggle("d-none")
            document.getElementById("newsBtnLoader").classList.toggle("d-none")

            if (!customer.id && !name) {
                setError("Please provide a valid customer name.")
            } else if (email && !configs.emailRegex.test(email)) {
                setError("Please provide a valid customer email.")
            } else if (mobile && !configs.phoneRegex.test(mobile)) {
                setError("Please provide a valid customer mobile")
            } else {
                let response = await createOrderLead(customer.id, name, email, mobile, CompanyName.name, investable_surplus, rate, cQuote, oQuote, aQuote, interested_in, remark, CompanyName.id)

                if (response && response === "success") {
                    resetValues()
                    setShowSuccess(true)
                    getRemarkByRemarkType(remarkListType, true, configs.allRecordsFetchedTillNow)
                } else {
                    setError(response)
                }
            }
            document.getElementById("newsBtn").classList.toggle("d-none")
            document.getElementById("newsBtnLoader").classList.toggle("d-none")
        } catch (error) {
            console.error(error);
        }
    }

    // add company function
    async function editRemarks() {
        try {

            document.getElementById("newsBtnEdit").classList.toggle("d-none")
            document.getElementById("newsBtnEditLoader").classList.toggle("d-none")

            if (!status) {
                setError("Please provide a valid status.")
            } else {
                let response = await editOrderLead(editRemarkData.id, status, cQuote, oQuote, aQuote, remark, quantity, orderType)

                if (response && response === "success") {
                    resetValues()
                    setShowSuccess(true)
                    getRemarkByRemarkType(remarkListType, true, configs.allRecordsFetchedTillNow)
                } else {
                    setError(response)
                }
            }
            document.getElementById("newsBtnEdit").classList.toggle("d-none")
            document.getElementById("newsBtnEditLoader").classList.toggle("d-none")
        } catch (error) {
        }
    }

    // reset all values
    function resetValues() {
        try {
            setCustomer({ id: "", name: "" })
            setCompanyName({ id: "", name: "" })
            setLastCallDate("")
            setRemark("")
            setInvestable_surplus("")
            setInterested_in("0")
            setError("")
            setEditRemark(false);
            setEditRemarkData({})
            setName("")
            setEmail("")
            setMobile("")
            setRate("")
            setCQuote("")
            setAQuote("")
            setOQuote("")
            setRemarkHistory([])
            setQuantity("");
            setOrderType("buy");
        } catch (error) {

        }
    }

    // create role ui code
    return (
        <div id="rmCreateNews" className="col-lg-3 col-md-4 d-md-block pt-3 main-rmPanel">
            <p className="h6 text-custom-grey">{editRemark ? "Edit Lead Status" : "Add a Order Lead"}</p>
            {!editRemark ?
                <form id="createRoleForm" action="" className='mr-1'>
                    <div className="form-group">
                        <label className="f-12">Customer</label>
                        {kycVerifiedList ? <Autocomplete
                            className="f-12"
                            id="companyIP"
                            value={customer}
                            placeholder="Customer Name"
                            getOptionLabel={option => option && option.email ? `${option.name} - ${option.email}` : ""}
                            onChange={handleCustomerChange}
                            options={kycVerifiedList}
                            renderInput={(params) => <TextField {...params} placeholder="Customer Name" className="f-12" onChange={getKYCVerifiedCustomer} />}
                        /> : null}
                    </div>
                    <p className='text-center m-2'>OR</p>
                    <div className="form-group">
                        <label className="f-12">Customer Name</label>
                        <input type="text" id="roleName" className="form-control f-10" placeholder="Customer Name" value={name} required onChange={(e) => {
                            setName(e.target.value)
                        }} />
                    </div>
                    <div className='row m-0 p-0'>
                        <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Customer E-mail</label>
                                <input type="text" id="roleName" className="form-control f-10" placeholder="Customr E-mail" value={email} required onChange={(e) => {
                                    setEmail(e.target.value)
                                }} />
                            </div>
                        </div>
                        <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Customer Mobile</label>
                                <input type="text" id="roleName" className="form-control f-10" placeholder="Customer Mobile" value={mobile} required onChange={(e) => {
                                    setMobile(e.target.value)
                                }} />
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="f-12">Select Company</label>
                        {companyList ? <Autocomplete
                            className="f-12"
                            id="companyIP"
                            value={CompanyName ? CompanyName : ""}
                            placeholder="Company Name"
                            getOptionLabel={option => option.name}
                            onChange={handleRMChange}
                            options={companyList}
                            renderInput={(params) => <TextField {...params} placeholder="Company Name" className="f-12" />}
                        /> : null}
                    </div>
                    <div className='row m-0 p-0'>
                        <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Order Type</label>
                                <select id="roleName" className="form-control f-10" placeholder="Interested in" value={interested_in} onChange={(e) => {
                                    setInterested_in(e.target.value)
                                }} >
                                    <option value="0">---Select an option---</option>
                                    <option value="BUY">Buy</option>
                                    <option value="SELL">Sell</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Quantity</label>
                                <input type="number" id="roleName" className="form-control f-10" placeholder="Quantity" value={investable_surplus} required onChange={(e) => {
                                    setInvestable_surplus(e.target.value)
                                }} />
                            </div>
                        </div>

                        {/* <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Rate/Share</label>
                                <input type="number" id="roleName" className="form-control f-10" placeholder="Rate/Share" value={rate} required onChange={(e) => {
                                    setRate(e.target.value)
                                }} />
                            </div>
                        </div> */}
                        <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Client Quote</label>
                                <input type="number" id="roleName" className="form-control f-10" placeholder="Client Quote" value={cQuote} required onChange={(e) => {
                                    setCQuote(e.target.value)
                                }} />
                            </div>
                        </div>
                        <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Our Quote</label>
                                <input type="number" id="roleName" className="form-control f-10" placeholder="Our Quote" value={oQuote} required onChange={(e) => {
                                    setOQuote(e.target.value)
                                }} />
                            </div>
                        </div>
                        {/* <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Approved Quote</label>
                                <input type="number" id="roleName" className="form-control f-10" placeholder="Approved Quote" value={aQuote} required onChange={(e) => {
                                    setAQuote(e.target.value)
                                }} />
                            </div>
                        </div> */}

                    </div>

                    <div className="form-group">
                        <label className="f-12">Call Remarks</label>
                        <textarea id="roleName" className="form-control f-10" placeholder="Call Remarks" value={remark} required onChange={(e) => {
                            setRemark(e.target.value)
                        }} />
                    </div>
                    <div className="form-check p-0">
                        <p className="text-danger" id="createRoleError">{error}</p>
                    </div>
                    <div className='row m-0 p-0'>
                        <div className='col-9 m-0 p-0'>
                            <button id="newsBtn" className="btn btn-primary f-12" onClick={(e) => {
                                e.preventDefault()
                                addRemark()
                            }}>{editRemark ? "Update Lead" : "Add Lead"}</button>
                            <div id="newsBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                        </div>
                        <div className='col-3 m-0 p-0'>
                            <button className="btn btn-primary f-12" onClick={(e) => {
                                e.preventDefault()
                                resetValues()
                            }}>Reset</button>
                        </div>
                    </div>
                    <div className='row m-0 p-0'>
                        <button className="btn btn-primary mt-3 f-12 d-md-none" onClick={(e) => {
                            e.preventDefault()
                            document.getElementById("rmCreateNews").classList.toggle('d-none')
                            document.getElementById("newsListPage").classList.toggle('d-none')
                            history.push('/orderinsight')
                        }}>View All Order Leads</button>
                    </div>
                </form>
                :
                <form id="createRoleForm" action="" className='mr-1'>
                    <div className='row m-0 p-0'>
                        <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Update Status </label>
                                <select className='form-control f-10' id="selectRemarkData" value={status} onChange={(e) => {
                                    e.preventDefault()
                                    setStatus(e.target.value)
                                }}>
                                    <option value="OPEN">Open</option>
                                    <option value="PROCESSED">Processed</option>
                                    <option value="REJECTED_BY_ALTIUS">Rejected by Altius</option>
                                    <option value="REJECTED_BY_USER">Rejected by Investor</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Order Type </label>
                                <select className='form-control f-10' id="selectRemarkData" value={orderType} onChange={(e) => {
                                    e.preventDefault()
                                    setOrderType(e.target.value)
                                }}>
                                    <option value="BUY">Buy</option>
                                    <option value="SELL">Sell</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Quantity</label>
                                <input type="number" id="roleName" className="form-control f-10" placeholder="Order Quantity" value={quantity} required onChange={(e) => {
                                    setQuantity(e.target.value)
                                }} />
                            </div>
                        </div>
                        <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Client Quote</label>
                                <input type="number" id="roleName" className="form-control f-10" placeholder="Client Quote" value={cQuote} required onChange={(e) => {
                                    setCQuote(e.target.value)
                                }} />
                            </div>
                        </div>
                        <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Our Quote</label>
                                <input type="number" id="roleName" className="form-control f-10" placeholder="Our Quote" value={oQuote} required onChange={(e) => {
                                    setOQuote(e.target.value)
                                }} />
                            </div>
                        </div>
                        {/* <div className='col-6 m-0 p-0'>
                            <div className="form-group">
                                <label className="f-12">Approved Quote</label>
                                <input type="number" id="roleName" className="form-control f-10" placeholder="Approved Quote" value={aQuote} required onChange={(e) => {
                                    setAQuote(e.target.value)
                                }} />
                            </div>
                        </div> */}
                    </div>
                    <div className="form-group">
                        <label className="f-12">Call Remarks</label>
                        <textarea id="roleName" className="form-control f-10" placeholder="Call Remarks" value={remark} required onChange={(e) => {
                            setRemark(e.target.value)
                        }} />
                    </div>
                    <div className="form-check p-0">
                        <p className="text-danger" id="createRoleError">{error}</p>
                    </div>
                    <div className='row m-0 p-0'>
                        <div className='col-9 m-0 p-0'>
                            <button id="newsBtnEdit" className="btn btn-primary f-12" onClick={(e) => {
                                e.preventDefault()
                                editRemarks()
                            }}>{editRemark ? "Update Lead" : "Add Lead"}</button>
                            <div id="newsBtnEditLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                        </div>
                        <div className='col-3 m-0 p-0'>
                            <button className="btn btn-primary f-12" onClick={(e) => {
                                e.preventDefault()
                                resetValues()
                            }}>Reset</button>
                        </div>
                    </div>
                    <div className='row m-0 p-0'>
                        <button className="btn btn-primary mt-3 f-12 d-md-none" onClick={(e) => {
                            e.preventDefault()
                            document.getElementById("rmCreateNews").classList.toggle('d-none')
                            document.getElementById("newsListPage").classList.toggle('d-none')
                            history.push('/orderinsight')
                        }}>View All Order Leads</button>
                    </div>
                    {remarkHistory && remarkHistory.length > 0 ?
                        <div className='mt-2'>
                            <p className='m-0 p-0 font-weight-bold'>Remark History</p>
                            {remarkHistory.map(element => {
                                return (
                                    <div className='card p-1'>
                                        <p className='mb-1 p-0 f-12'><b>Remark-</b>{element.remark}</p>
                                        <div className='row m-0 p-0'>
                                            <div className='col-6 m-0 p-0'>
                                                <p className='m-0 p-0 f-9 font-weight-bold'>Remark by:</p>
                                            </div>
                                            <div className='col-6 m-0 p-0 text-right'>
                                                <p className='m-0 p-0 f-9 font-weight-bold'>Remark Timestamp</p>
                                            </div>
                                        </div>
                                        <div className='row m-0 p-0'>
                                            <div className='col-6 m-0 p-0'>
                                                <p className='m-0 p-0 f-9'>{element.admin.name}</p>
                                            </div>
                                            <div className='col-6 m-0 p-0 text-right'>
                                                <p className='m-0 p-0 f-9'>{element.datetime}</p>
                                            </div>
                                        </div>
                                        <div className='row m-0 p-0'>
                                            <div className='col-4 m-0 p-0'>
                                                <p className='m-0 p-0 f-9 font-weight-bold'>Client Quote</p>
                                            </div>
                                            <div className='col-4 m-0 p-0'>
                                                <p className='m-0 p-0 f-9 font-weight-bold'>Our Quote</p>
                                            </div>
                                            <div className='col-4 m-0 p-0'>
                                                <p className='m-0 p-0 f-9 font-weight-bold'>Approved Quote</p>
                                            </div>
                                        </div>
                                        <div className='row m-0 p-0'>
                                            <div className='col-4 m-0 p-0'>
                                                <p className='m-0 p-0 f-9'>{formatCurrency(parseFloat(element.client_quote))}</p>
                                            </div>
                                            <div className='col-4 m-0 p-0'>
                                                <p className='m-0 p-0 f-9'>{formatCurrency(parseFloat(element.our_quote))}</p>
                                            </div>
                                            <div className='col-4 m-0 p-0'>
                                                <p className='m-0 p-0 f-9'>{formatCurrency(parseFloat(element.approved_quote))}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div> : null}
                </form>
            }
        </div>
    )
}